import { Accordion } from './Accordion';

export type { TypeAccordionProps } from './types';

export default Accordion;
